import React, { useState} from "react";
import Header from "../components/Header";

const Steelwork = () => {
  const [selectedOption, setSelectedOption] = useState('slab');
  const [length, setLength]= useState(0);
  const [breadth, setBreadth]= useState(0);
  const [width, setWidth]= useState(0);
    const [topPiece, setTopPiece]= useState(0);
    const [diamTopPiece, setDiamTopPiece]= useState("");
    const [bottomPiece, setBottomPiece]= useState(0);
      const [diamBottomPiece, setDiamBottomPiece]= useState("");
  const [reinforcement, setReinforcement]= useState(0);
  const [Quantity, setQuantity]= useState(0);
  const [result, setResult]= useState('');
   const [showResult, setShowResult] = useState(false);
  
  
   const handleRadioChange =(e)=>{
    setSelectedOption(e.target.value);
     setResult(0);
     setShowResult(false);
}


  const  calculateBeam=()=> {
    let topBeam = parseFloat(topPiece); 
    let bottmBeam=parseFloat(bottomPiece);
    if (!length || !breadth ||  !width || !Quantity){
      alert(" Please fill all the fields");
      return;
    }
    else if (
        isNaN(length) || isNaN(breadth) || isNaN(width) 
      ) {
        alert("Please enter valid numerical values for all steel inputs.");
        return;
      }
       
    
    //     if (breadth>= 0.225 || breadth <= 0.3){
    //     beamLength = 2
      
    // }
    // else if (breadth> 0.300 || breadth <= 0.45) {
    //     beamLength = 3;
        
    // } 
    // else if (breadth> 0.450 || breadth <= 0.6){
    //     beamLength = 4
   
    // }
    // else if (breadth > 0.6 || breadth <= 0.75){
    //     beamLength = 6
      
    // }
    // else if (breadth > 0.75) {
    //     beamLength = 8
      
    // }
    // else{
       
    //     alert('Invalid input!!!, breadth should be atleast thickness of blockwork');
    
    // }
 
    
                

    //     if (width>= 0.225 || width <= 0.300){
    //         beamBreadth = 2
       
    // }
    // else if (width > 0.300 || width <= 0.450) {
    //     beamBreadth = 3;
   
    // } 
    // else if (width > 0.450 || width <= 0.600){
    //     beamBreadth = 4;
   
    // }
    // else if (width > 0.600 || width <= 0.750){
    //     beamBreadth = 6;
   
    // }
    // else if (width > 0.750) {
    //     beamBreadth = 8;
   
    // }
    
    // else{alert('Invalid input!!!, Width should be atleast thickness of blockwork');
    
    
    // }
    
const L =parseFloat(length)
    const T1= (L+0.200)* (topBeam)
    const T2 = (L+0.200) *(bottmBeam)
    const totalSteel = T1+T2;
    //for seperate bottom and top
    const quantityT1 = T1 * parseFloat(Quantity);
    const quantityT2 = T2 * parseFloat(Quantity);

    const quantityIncld = totalSteel * parseFloat(Quantity);
//for seperate bottom and top
    const T1Final=quantityT1/12;
    const T2Final=quantityT2/12;
    const TFinal = quantityIncld/12;
    
    const NoOfLinks = parseFloat(Quantity)*((L/0.200) + 1);
    const linksPerimeter = 2*(parseFloat(width) + parseFloat(breadth))+ 0.1;
    const totalLinkLength = NoOfLinks *linksPerimeter;
    const TLinkFinal = totalLinkLength/12;
   
    
// Simplified calculation: Length * steel count
      // Simplified calculation: Link length * steel count
    
        // Display the results in the correct htmlFormat
        setResult({
          quantityIncld: quantityIncld.toFixed(3),
          quantityT1:quantityT1.toFixed(2),
          quantityT2:quantityT2.toFixed(2),
          TFinal:TFinal.toFixed(2),
          T1Final:T1Final.toFixed(2),
          T2Final:T2Final.toFixed(2),
          NoOfLinks:NoOfLinks.toFixed(2),
          linksPerimeter:linksPerimeter.toFixed(2),
          totalLinkLength:totalLinkLength.toFixed(2),
          TLinkFinal:TLinkFinal.toFixed(2),
       diamTopPiece:diamTopPiece.toUpperCase(),
       diamBottomPiece:diamBottomPiece.toUpperCase()

        });
       setShowResult(true); 
  }
  


  const calculateSlab = () =>{

    const spacing = 0.15;
if (
        isNaN(length) || isNaN(breadth) || isNaN(width) 
      ) {
        alert("Please enter valid numerical values for all steel inputs.");
        return;
      }
         else if (!length || !breadth ){
      alert("Please Fill in all the fields");
      return
    }


if (reinforcement === "single") {
    let konstant=0;

  if(length>= 1 ||length<=2){
      konstant = 0.2;
  }
   else if  (length>2 || length<= 6)
        {
    konstant = 1;
        }
        else {
    konstant = 1.2;
        }
   const L = parseFloat(length);
   const B=parseFloat(breadth);
    
    
        const FL = (L/spacing) + 1; // Simplified calculation: Length / steel spacing
        const FB = (B/spacing) + 1; // Simplified calculation: Breadth / steel spacing
  
        const FLT = FL *(B+konstant ); // Simplified calculation: FL x Breadth + 1.2 or 2
        const FBT = FB *(L+ konstant); // Simplified calculation: FB x Length + 1.2 or 2
        const total =FLT + FBT; // Simplified calculation: FLT.........
        const percentage = (5/100)* total; // Simplified calculation: 5%
        const final = total + percentage; // Simplified calculation: total + 5%
    const display = final/12;
        // Simplified calculation: Link length * steel count
    
        setResult({
final: final.toFixed(2),
display:display.toFixed(2)


        });
        // Display the results in the correct format
      
} 
else if (reinforcement === "double") {
  const L = parseFloat(length)
  const B = parseFloat(breadth)
    const FL = (L/spacing) + 1; // Simplified calculation: Length / steel spacing
        const FB = (B/spacing) + 1; // Simplified calculation: Breadth / steel spacing
        const FLT = FL *B ; // Simplified calculation: FL x Breadth +1.5 or 2
        const FBT = FB *L; // Simplified calculation: FB x Length + 1.5 or 2
        const total =2*(FLT + FBT); // Simplified calculation: FLT.........
        const percentage = (5/100)* total; // Simplified calculation: 5%
        const final = total + percentage; // Simplified calculation: total + 5%
    const display = final/12; // Final Simplified calculation : final/12 which is the length of steel from the manufacturer
    
        // Display the results in the correct format
        setResult({
         final: final.toFixed(2),
         display:display.toFixed(2)
        
        });
      
  
  }
  setShowResult(true);
  }


  const calculateColumn= () => {
    let columnBreadth = 0;
    let columnLength=0;

if (
        isNaN(length) || isNaN(breadth) || isNaN(width) 
      ) {
        alert("Please enter valid numerical values for all steel inputs.");
        return;
      }
        else if (!length || !breadth || !width || !Quantity){
      alert("Please Fill in all the fields");
      return
    }

    if (breadth>= 0.225 || breadth <= 0.300){
    columnBreadth = 2
   
}
else if (breadth > 0.300 || breadth <= 0.450) {
    columnBreadth = 3;
   
} 
else if (breadth> 0.450 || breadth <= 0.600){
    columnBreadth = 4
   
}
else if (breadth > 0.600 || breadth <= 0.750){
    columnBreadth = 6
   
}
else if (breadth > 0.750) {
    columnBreadth = 8
   
}
else{
  alert('Invalid input!!!, breadth should be atleast thickness of blockwork');


}


    if (length>= 0.225 || length <= 0.300){
      columnLength = 2
    
}
else if (length > 0.300 || length <= 0.450) {
    columnLength = 3;
  
} 
else if (length> 0.450 || length <= 0.600){
    columnLength = 4
  
}
else if (length > 0.600 || length <= 0.750){
    columnLength = 6
  
}
else if (length > 0.750) {
    columnLength = 8
  
}

else{
  alert('Invalid input!!!, breadth should be atleast thickness of blockwork');
}
const W= parseFloat(width);
const totalSteel = (W+0.200) *columnBreadth * columnLength;
 const quantityIncld = totalSteel * parseFloat(Quantity);
    const TFinal = quantityIncld/12;

const NoOfLinks = parseFloat(Quantity)*((W/0.200) + 1);
const linksPerimeter = 2 * (parseFloat(length) + parseFloat(breadth))+ 0.1;
const totalLinkLength = NoOfLinks *linksPerimeter;
const TLinkFinal = totalLinkLength/12;

// Simplified calculation: Length * steel count
     // Simplified calculation: Link length * steel count
   
          
          
    setResult({
     quantityIncld: quantityIncld.toFixed(3),
     TFinal:TFinal.toFixed(2),
     NoOfLinks:NoOfLinks.toFixed(2),
     linksPerimeter:linksPerimeter.toFixed(2),
     totalLinkLength:totalLinkLength.toFixed(2),
     TLinkFinal: TLinkFinal.toFixed(2)

    });
    // Display the results in the correct format
  setShowResult(true);
  }

  
    return ( 
     <div className="container">
      <Header/>
  <div className="estimation-container">

    <fieldset className="steel-toggle-container">
      <legend>Steel Estimation</legend>
    {/* Fieldset for Steel Estimation */}
    <fieldset className="steel-toggle">
      

      {/* Toggle Buttons: Beam, Slab, Column */}
      <div className="toggle-contain">
        
          <input type="radio" name="steelType" value="beam" checked={selectedOption === 'beam'} onChange={handleRadioChange}   />
            <label htmlFor="slab"> Beam </label> 
       
     
          <input type="radio" name="steelType" value="slab" checked={selectedOption === 'slab'} onChange={handleRadioChange}/>
          <label htmlFor="slab"> Slab </label>    
        
        
          <input type="radio" name="steelType" value="column" checked={selectedOption === 'column'} onChange={handleRadioChange}/>
           <label htmlFor="slab"> Column </label>
        
      </div>
      </fieldset>

      
      {/* Beam Form */}
      {selectedOption==='beam' && <div className="form-content">
      <fieldset>
        <label htmlFor="beamLength">Length (m):</label>
        <input type="number" id="beamLength" placeholder="Enter length in meters" onChange={(e)=> setLength(e.target.value)} />

        <label htmlFor="beamBreadth">Breadth of Beam:</label>
        <input type="number" id="beamBreadth" placeholder="Enter Width in meters" onChange={(e)=> setBreadth(e.target.value)} />

        <label htmlFor="beamThickness">Height of Beam:</label>
        <input type="number" id="beamThickness" placeholder="Enter  Thickness/Height in meters" onChange={(e)=> setWidth(e.target.value)} />
 
 
  <label htmlFor="beamThickness">Number of Reinforment Bars at the Top:</label>
        <input type="number" id="beamThickness" placeholder="Enter  Number of Top Bars" onChange={(e)=> setTopPiece(e.target.value)} />
  <label htmlFor="beamThickness">Diameter of Reinforcement Bars at the Top:</label>
        <input type="text" id="beamThickness" placeholder="Top Bar size(mm) e.g Y16" onChange={(e)=> setDiamTopPiece(e.target.value)} />
  <label htmlFor="beamThickness">Number of Reinforment Bars at the Bottom:</label>
        <input type="number" id="beamThickness" placeholder="Enter  Number of Bottom Bars " onChange={(e)=> setBottomPiece(e.target.value)} />
  <label htmlFor="beamThickness">Diameter of Reinforcement Bars at the Bottom:</label>
        <input type="text" id="beamThickness" placeholder="Bottom Bar size(mm) e.g Y16" onChange={(e)=> setDiamBottomPiece(e.target.value)} />
 
 <label htmlFor="beamThickness">Quantity of Beams with thesame Dimension:</label>
        <input type="number" id="beamThickness" placeholder="Enter  Beam Quantity" onChange={(e)=> setQuantity(e.target.value)} />
        {/* <label htmlFor="beamSteelType">Steel Type:</label>
        <select id="beamSteelType">
          <option value="6mm">6mm</option>
          <option value="8mm">8mm</option>
          <option value="12mm">12mm</option>
          <option value="16mm">16mm</option>
          <option value="20mm">20mm</option>
          <option value="25mm">25mm</option>
            <option value="32mm">32mm</option>
              <option value="40mm">40mm</option>
        </select> */}

     
    
        <button className="submit" type="button" onClick={() => calculateBeam()}>Submit</button>

       

        </fieldset>
      </div>
     
      }

      {/* Slab Form */}
      {selectedOption==='slab' && <div className="form-content" >
      <fieldset>
        <label htmlFor="slabLength">Length (m):</label>
        <input type="number" id="slabLength" placeholder="Enter length in meters" onChange={(e)=> setLength(e.target.value)} />

        <label htmlFor="slabBreadth">Breadth (m):</label>
        <input type="number" id="slabBreadth" placeholder="Enter breadth in meters" onChange={(e)=> setBreadth(e.target.value)} />

        <label htmlFor="reinforcementType">Steel Type:</label>
        <select id="reinforcement" onChange={(e)=> setReinforcement(e.target.value)}>
        
          <option value="single">Single Reinforcement Slab</option>
          <option value="double">Double Reinforcement Slab</option>
        </select>

        <label htmlFor="slabSteelType">Steel Type:</label>
        <select id="slabSteelType" >
          <option value="6mm">6mm</option>
          <option value="8mm">8mm</option>
          <option value="12mm">12mm</option>
          <option value="16mm">16mm</option>
          <option value="20mm">20mm</option>
          <option value="25mm">25mm</option>
            <option value="32mm">32mm</option>
              <option value="40mm">40mm</option>
        </select>

        <button className="submit" type="button" onClick={() => calculateSlab()}>Submit</button>

       
        </fieldset>
      </div>
}
      {/* Column Form */}
      {selectedOption==='column' &&<div className="form-content" >
      <fieldset>
        <label htmlFor="columnHeight">Height (m):</label>
        <input type="text" id="columnHeight" placeholder="Enter Height in meters" onChange={(e)=> setWidth(e.target.value)} required />

        <label htmlFor="columnLength">Length:</label>
        <input type="text" id="columnLength" placeholder="Enter Length in meters" onChange={(e)=> setLength(e.target.value)}   required />

        <label htmlFor="columnBreadth">Breadth (m):</label>
        <input type="text" id="columnBreadth" placeholder="Enter Breadth in meters" onChange={(e)=> setBreadth(e.target.value)}  required />

        <label htmlFor="beamThickness">Quantity of Columns:</label>
        <input type="number" id="beamThickness" placeholder="Enter  Column Quantity" onChange={(e)=> setQuantity(e.target.value)} />


        <label htmlFor="columnSteelType">Steel Type:</label>
        <select id="columnSteelType" >
          <option value="6mm">6mm</option>
          <option value="8mm">8mm</option>
          <option value="12mm">12mm</option>
          <option value="16mm">16mm</option>
          <option value="20mm">20mm</option>
          <option value="25mm">25mm</option>
            <option value="32mm">32mm</option>
              <option value="40mm">40mm</option>
        </select>

        <button className="submit" type="button" onClick={() => calculateColumn()}>Submit</button>

      
        </fieldset>
      </div>
      
}
</fieldset>
{showResult && (
  <div className="result-wrapper" onClick={() => setShowResult(false)}>
    <div className="result-display" onClick={(e) => e.stopPropagation()}>
      <div className="close-result" onClick={() => setShowResult(false)}>X</div>

      {selectedOption === 'slab' ? (
        <div className="answer-labels">
          <label>Total Bar Length: <strong>{result.final} m</strong></label>
          <label>Bars to buy (12m each): <strong>{result.display} piece/pieces</strong></label>
          <p>5% contingency has been included</p>
        </div>
      ) : (
        <div className="answer-labels">
          {diamTopPiece?.toUpperCase() === diamBottomPiece?.toUpperCase() && topPiece === bottomPiece ? (
            <>
              <p>Total Bar Length Needed: <strong>{result.quantityIncld} m</strong></p>
              <p>Bars to buy (12m each): <strong>{result.TFinal} pieces</strong></p>

              <p>Links Bending Details</p>
              <p>Total Number of Links: <strong>{result.NoOfLinks} Links</strong></p>
              <p>Cut {result.linksPerimeter} m length for each link</p>
              <p>Total Length of All Links: <strong>{result.totalLinkLength}</strong></p>
              <p>Bars to buy for links (12m each): <strong>{result.TLinkFinal} piece/pieces</strong></p>
            </>
          ) : (
            <>
              <p>Top Bar Length Needed: <strong>{result.quantityT1} m Size: {result.diamTopPiece}</strong></p>
              <p>Bottom Bar Length Needed: <strong>{result.quantityT2} m Size: {result.diamBottomPiece}</strong></p>

              <p>Top Bars to buy (12m each): <strong>{result.T1Final} pieces</strong></p>
              <p>Bottom Bars to buy (12m each): <strong>{result.T2Final} pieces</strong></p>

              <p>Links Bending Details</p>
              <p>Total Number of Links: <strong>{result.NoOfLinks} Links</strong></p>
              <p>Cut {result.linksPerimeter} m length for each link</p>
              <p>Total Length of All Links: <strong>{result.totalLinkLength}</strong></p>
              <p>Bars to buy for links (12m each): <strong>{result.TLinkFinal} piece/pieces</strong></p>
            </>
          )}
        </div>
      )}
    </div>
  </div>
)}

     
  </div>

    </div>
        
     );
}

export default Steelwork;